import moduleServices from '@/services/module';
import router from '@/router';
import { loadRoute } from '@/helpers/page';
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

const setModule = async (dispatch, rootState, module) => {
  const defaultPage = await getDefaultPage(rootState);
  let page, mode, hasDictionaryReturns;
  let hasPageAndModeByConfigLayout = false;

  if (defaultPage !== null) {
    page = defaultPage.Page;
    mode = defaultPage.Mode;
    hasPageAndModeByConfigLayout = true;
  }
  if (!(hasPageAndModeByConfigLayout)) {
    const { data } = await moduleServices.getDefaultPage(module);

    hasDictionaryReturns = (data.dictionaryReturns['@id_retorno'] === 0);
    if (hasDictionaryReturns && data.values.length > 0) {
      page = data.values[0].Page;
      mode = data.values[0].Mode;
    }
  }


  if (hasDictionaryReturns || hasPageAndModeByConfigLayout) {
    dispatch('page/setMain', page, { root: true });

    const menuItem = await getMenu(rootState, page);

    await loadRoute({ page, mode, breadCrumbs: menuItem, dashboardNome: page, target: 'page' });
    await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
  }
  else {
    router.history.current.path != '/dashboard' && router.push({ path: '/dashboard' });
  }
};

const getDefaultPage = async (state) => {
  // Trava o redirect em 100ms para setar menu e modulos permitidos antes de finalizar o push para Page.
  //  Ação necessária quando utilizado 'defaultPage' no configLayout
  //  TODO: Atualizar vue-router para push em cascatas
  await new Promise((r) => setTimeout((r), 100));
  return ('Page' in state.layout.defaultPage && 'Mode' in state.layout.defaultPage) ? state.layout.defaultPage : null;
};

const getMenu = (state, page) => {
  let menu = state.menu.menu;

  let result = '';

  for (let item in menu) {
    if (menu[item].children) {
      for (let itemChildren in menu[item].children) {
        let forItem = menu[item].children[itemChildren];
        if (forItem.page == page) {
          result = forItem;
        }
        else if (forItem.children) {
          for (let itemChildren2 in forItem.children) {
            let itemFor = forItem.children[itemChildren2];
            if (itemFor.page) {
              if (itemFor.page == page) {
                result = itemFor;
              }
            }
          }
        }
      }
    }
  }

  return result;
};

export default {
  getModules: async ({ commit }) => {
    try {
      const { data } = await moduleServices.getModules();

      if (data) {
        commit('setModules', data);
      }
    } catch (err) {
      console.error(err);
    }
  },

  getDefaultModule: async ({ state, dispatch }) => {
    if (!!state.defaultModule)
      return;

    try {
      const { data } = await moduleServices.getDefaultModule();

      if (data) {
        await dispatch('getModulesAllowed');
        await dispatch('setDefaultModule', data);
      }
    } catch (err) {
      console.error(err);
    }
  },

  setDefaultModule: async ({ commit, dispatch, rootState }, module) => {
    try {
      await commit('setDefaultModule', module);

      if (!rootState.authentication.config.DEV_MODULE) {
        dispatch('menu/getMenu', { moduleId: module }, { root: true });
        dispatch('menu/getSuspendedMenu', { moduleId: module }, { root: true });
        setModule(dispatch, rootState, module);
      }

    } catch (err) {
      console.error(err);
    }
  },

  getModulesAllowed: async ({ commit }) => {
    try {
      const { data } = await moduleServices.getModulesAllowed();

      if (data) {
        commit('setModulesAllowed', data);
      }
    } catch (err) {
      console.error(err);
    }
  }
};

